import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faShoppingCart, faSun } from "@fortawesome/free-solid-svg-icons";
import * as S from "./menu-footer.styles";
import { useCart } from "../../../../../../hooks/use-cart-hook";
import { useThemeSwitcher } from "../../../../../../context/theme/theme-context";
import { useTheme } from "styled-components";
import type { MenuFooterProps } from "./types";
import { Link } from "react-router-dom";

export const MenuFooter = ({ onClose }: MenuFooterProps) => {
    const { toggleTheme } = useThemeSwitcher();
    const theme = useTheme().mode;
    const { openCart } = useCart();

    return (
        <S.Container>
            <S.PrimaryButton onClick={openCart} aria-label="Abrir carrinho">
                <S.IconWrapperPrimary>
                    <FontAwesomeIcon icon={faShoppingCart} />
                </S.IconWrapperPrimary>
                <span>Carrinho</span>
            </S.PrimaryButton>

            <S.SecondaryButton onClick={toggleTheme} aria-label="Alterar cores do site">
                <S.IconWrapperSecondary>
                    <FontAwesomeIcon icon={theme === 'dark' ? faMoon : faSun} />
                </S.IconWrapperSecondary>
                <span>Alterar tema</span>
            </S.SecondaryButton>

            <S.FooterLinks>
                <Link to="/termos" onClick={onClose}>Termos de Uso</Link>
            </S.FooterLinks>
        </S.Container>
    );
};
